export type InsideCanvasHandling = "ignore" | "background-only";

export interface OutsideClickClearOptions {
  canvasId: string;
  legendId?: string;
  resolvePanelRoot: (canvas: HTMLElement | null) => HTMLElement | null;
  insideCanvasHandling: InsideCanvasHandling;
  getChart?: () => any | null;
  shouldSkip?: () => boolean;
  onClear: () => void;
}

export function registerOutsideClickClear(options: OutsideClickClearOptions) {
  const handler = (e: MouseEvent) => {
    const canvas = document.getElementById(options.canvasId) as HTMLElement | null;
    const legend = options.legendId ? (document.getElementById(options.legendId) as HTMLElement | null) : null;
    const target = e.target as Node | null;

    const insideCanvas = !!(canvas && target && canvas.contains(target));
    const insideLegend = !!(legend && target && legend.contains(target));

    if (insideLegend) return;

    if (options.insideCanvasHandling === "ignore") {
      if (insideCanvas) return;
    } else if (options.insideCanvasHandling === "background-only") {
      if (insideCanvas) {
        try {
          const chart = options.getChart ? options.getChart() : null;
          const activePoints = chart?.getElementsAtEvent ? chart.getElementsAtEvent(e) : [];
          const isBackgroundInsideCanvas = !(activePoints && activePoints[0]);
          if (!isBackgroundInsideCanvas) return;
        } catch {
          return;
        }
      }
    }

    const panel = options.resolvePanelRoot(canvas);
    const insidePanel = !!(panel && target && panel.contains(target));

    if (options.insideCanvasHandling === "background-only") {
      if (!insideCanvas && !insidePanel) return;
    } else {
      if (!insidePanel) return;
    }

    if (options.shouldSkip && options.shouldSkip()) return;

    options.onClear();
  };

  document.addEventListener("mousedown", handler);
  return () => document.removeEventListener("mousedown", handler);
}
